import type { components } from "@/shared/api";

type CheckoutIn = components["schemas"]["CheckoutIn"];

// Способ оплаты в окне: автоплатёж (только СБП) или разовая оплата через СБП или картой.
export type CheckoutWay = "autopay" | "sbp" | "card";

export const CHECKOUT_WAYS: readonly CheckoutWay[] = ["autopay", "sbp", "card"];

export const checkoutBody = (way: CheckoutWay): CheckoutIn =>
  way === "autopay" ? { mode: "autopay", method: "sbp" } : { mode: "one_time", method: way };
